import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react'
import { Shield, Search, ChevronLeft, ChevronRight } from 'lucide-react'
import s from './PanelBase.module.scss'
import { SectionHeading, EmptyState } from 'components/Erp/Presentation'

const GuardsPanel = ({
  guardsFilter,
  setGuardsFilter,
  filteredGuards,
  guardsPagination,
  loadGuardsPage,
}) => {
  useInterfaceLanguage();
  return (
    <div className={s.panel}>
      <div className={s.header}>
        <SectionHeading icon={Shield} title={tr("Охрана КПП")} />
        {tr(guardsPagination?.count > 0 && (
          <span className={s.totalBadge}>{tr("Всего: ")}{tr(guardsPagination.count)}</span>
        ))}
      </div>

      <div className={s.searchRow}>
        <Search size={16} aria-hidden="true" />
        <input className={s.searchInput} placeholder={tr("Поиск по сотруднику...")} value={guardsFilter} onChange={(e) => setGuardsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadGuardsPage(1, guardsFilter) }} />
      </div>

      {filteredGuards && filteredGuards.length ? (
        <div className={s.tableWrap}>
          <div className={s.tableScroll}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>{tr("Сотрудник")}</th>
                <th>{tr("Телефон")}</th>
                <th>{tr("Доп. телефон")}</th>
                <th>{tr("Статус")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredGuards.map((g, index) => (
                <tr key={g.id}>
                  <td data-label={tr("№")} className={s.numCell}>{tr(index + 1)}</td>
                  <td data-label={tr("Сотрудник")} style={{ fontWeight: 600, color: "var(--theme-text, #1e293b)" }}>{tr(g.employee_name || `#${g.id}`)}</td>
                  <td data-label={tr("Телефон")}>{tr(g.employee_phone || '—')}</td>
                  <td data-label={tr("Доп. телефон")}>{tr(g.phone || '—')}</td>
                  <td data-label={tr("Статус")}>
                    <span className={`${s.badge} ${g.is_active ? s.active : s.inactive}`}>
                      {g.is_active ? tr("Активен") : tr("Неактивен")}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      ) : (
        <EmptyState icon={Shield} title={tr("Список пуст")} description={tr("Измените поиск или проверьте записи в этом разделе.")} compact />
      )}

      {tr(!guardsFilter && guardsPagination?.count > 0 && (
        <div className={s.pagination}>
          <button className={s.pageBtn} disabled={!guardsPagination.previous} onClick={() => loadGuardsPage((guardsPagination.page || 1) - 1)}><ChevronLeft size={15} aria-hidden="true" />{tr("Пред.")}</button>
          <span>{tr("Стр. ")}{tr(guardsPagination.page || 1)}{tr(" из ")}{Math.ceil(guardsPagination.count / 25)}</span>
          <button className={s.pageBtn} disabled={!guardsPagination.next} onClick={() => loadGuardsPage((guardsPagination.page || 1) + 1)}>{tr("След.")}<ChevronRight size={15} aria-hidden="true" /></button>
        </div>
      ))}
    </div>
  )
}

export default GuardsPanel
